const tokens = {
  "aspectRatios.square": {
    "value": "1 / 1",
    "variable": "var(--wa-aspect-ratios-square)"
  },
  "aspectRatios.landscape": {
    "value": "4 / 3",
    "variable": "var(--wa-aspect-ratios-landscape)"
  },
  "aspectRatios.portrait": {
    "value": "3 / 4",
    "variable": "var(--wa-aspect-ratios-portrait)"
  },
  "aspectRatios.wide": {
    "value": "16 / 9",
    "variable": "var(--wa-aspect-ratios-wide)"
  },
  "aspectRatios.ultrawide": {
    "value": "18 / 5",
    "variable": "var(--wa-aspect-ratios-ultrawide)"
  },
  "aspectRatios.golden": {
    "value": "1.618 / 1",
    "variable": "var(--wa-aspect-ratios-golden)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--wa-borders-none)"
  },
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--wa-blurs-sm)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--wa-blurs-base)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--wa-blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--wa-blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--wa-blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--wa-blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--wa-blurs-3xl)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--wa-animations-spin)"
  },
  "animations.ping": {
    "value": "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    "variable": "var(--wa-animations-ping)"
  },
  "animations.pulse": {
    "value": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--wa-animations-pulse)"
  },
  "animations.bounce": {
    "value": "bounce 1s infinite",
    "variable": "var(--wa-animations-bounce)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--wa-colors-current)"
  },
  "colors.black": {
    "value": "#000",
    "variable": "var(--wa-colors-black)"
  },
  "colors.white": {
    "value": "#fff",
    "variable": "var(--wa-colors-white)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--wa-colors-transparent)"
  },
  "colors.rose.50": {
    "value": "#fff1f2",
    "variable": "var(--wa-colors-rose-50)"
  },
  "colors.rose.100": {
    "value": "#ffe4e6",
    "variable": "var(--wa-colors-rose-100)"
  },
  "colors.rose.200": {
    "value": "#fecdd3",
    "variable": "var(--wa-colors-rose-200)"
  },
  "colors.rose.300": {
    "value": "#fda4af",
    "variable": "var(--wa-colors-rose-300)"
  },
  "colors.rose.400": {
    "value": "#fb7185",
    "variable": "var(--wa-colors-rose-400)"
  },
  "colors.rose.500": {
    "value": "#f43f5e",
    "variable": "var(--wa-colors-rose-500)"
  },
  "colors.rose.600": {
    "value": "#e11d48",
    "variable": "var(--wa-colors-rose-600)"
  },
  "colors.rose.700": {
    "value": "#be123c",
    "variable": "var(--wa-colors-rose-700)"
  },
  "colors.rose.800": {
    "value": "#9f1239",
    "variable": "var(--wa-colors-rose-800)"
  },
  "colors.rose.900": {
    "value": "#881337",
    "variable": "var(--wa-colors-rose-900)"
  },
  "colors.rose.950": {
    "value": "#4c0519",
    "variable": "var(--wa-colors-rose-950)"
  },
  "colors.pink.50": {
    "value": "#fdf2f8",
    "variable": "var(--wa-colors-pink-50)"
  },
  "colors.pink.100": {
    "value": "#fce7f3",
    "variable": "var(--wa-colors-pink-100)"
  },
  "colors.pink.200": {
    "value": "#fbcfe8",
    "variable": "var(--wa-colors-pink-200)"
  },
  "colors.pink.300": {
    "value": "#f9a8d4",
    "variable": "var(--wa-colors-pink-300)"
  },
  "colors.pink.400": {
    "value": "#f472b6",
    "variable": "var(--wa-colors-pink-400)"
  },
  "colors.pink.500": {
    "value": "#ec4899",
    "variable": "var(--wa-colors-pink-500)"
  },
  "colors.pink.600": {
    "value": "#db2777",
    "variable": "var(--wa-colors-pink-600)"
  },
  "colors.pink.700": {
    "value": "#be185d",
    "variable": "var(--wa-colors-pink-700)"
  },
  "colors.pink.800": {
    "value": "#9d174d",
    "variable": "var(--wa-colors-pink-800)"
  },
  "colors.pink.900": {
    "value": "#831843",
    "variable": "var(--wa-colors-pink-900)"
  },
  "colors.pink.950": {
    "value": "#500724",
    "variable": "var(--wa-colors-pink-950)"
  },
  "colors.fuchsia.50": {
    "value": "#fdf4ff",
    "variable": "var(--wa-colors-fuchsia-50)"
  },
  "colors.fuchsia.100": {
    "value": "#fae8ff",
    "variable": "var(--wa-colors-fuchsia-100)"
  },
  "colors.fuchsia.200": {
    "value": "#f5d0fe",
    "variable": "var(--wa-colors-fuchsia-200)"
  },
  "colors.fuchsia.300": {
    "value": "#f0abfc",
    "variable": "var(--wa-colors-fuchsia-300)"
  },
  "colors.fuchsia.400": {
    "value": "#e879f9",
    "variable": "var(--wa-colors-fuchsia-400)"
  },
  "colors.fuchsia.500": {
    "value": "#d946ef",
    "variable": "var(--wa-colors-fuchsia-500)"
  },
  "colors.fuchsia.600": {
    "value": "#c026d3",
    "variable": "var(--wa-colors-fuchsia-600)"
  },
  "colors.fuchsia.700": {
    "value": "#a21caf",
    "variable": "var(--wa-colors-fuchsia-700)"
  },
  "colors.fuchsia.800": {
    "value": "#86198f",
    "variable": "var(--wa-colors-fuchsia-800)"
  },
  "colors.fuchsia.900": {
    "value": "#701a75",
    "variable": "var(--wa-colors-fuchsia-900)"
  },
  "colors.fuchsia.950": {
    "value": "#4a044e",
    "variable": "var(--wa-colors-fuchsia-950)"
  },
  "colors.violet.50": {
    "value": "#f5f3ff",
    "variable": "var(--wa-colors-violet-50)"
  },
  "colors.violet.100": {
    "value": "#ede9fe",
    "variable": "var(--wa-colors-violet-100)"
  },
  "colors.violet.200": {
    "value": "#ddd6fe",
    "variable": "var(--wa-colors-violet-200)"
  },
  "colors.violet.300": {
    "value": "#c4b5fd",
    "variable": "var(--wa-colors-violet-300)"
  },
  "colors.violet.400": {
    "value": "#a78bfa",
    "variable": "var(--wa-colors-violet-400)"
  },
  "colors.violet.500": {
    "value": "#8b5cf6",
    "variable": "var(--wa-colors-violet-500)"
  },
  "colors.violet.600": {
    "value": "#7c3aed",
    "variable": "var(--wa-colors-violet-600)"
  },
  "colors.violet.700": {
    "value": "#6d28d9",
    "variable": "var(--wa-colors-violet-700)"
  },
  "colors.violet.800": {
    "value": "#5b21b6",
    "variable": "var(--wa-colors-violet-800)"
  },
  "colors.violet.900": {
    "value": "#4c1d95",
    "variable": "var(--wa-colors-violet-900)"
  },
  "colors.violet.950": {
    "value": "#2e1065",
    "variable": "var(--wa-colors-violet-950)"
  },
  "colors.indigo.50": {
    "value": "#eef2ff",
    "variable": "var(--wa-colors-indigo-50)"
  },
  "colors.indigo.100": {
    "value": "#e0e7ff",
    "variable": "var(--wa-colors-indigo-100)"
  },
  "colors.indigo.200": {
    "value": "#c7d2fe",
    "variable": "var(--wa-colors-indigo-200)"
  },
  "colors.indigo.300": {
    "value": "#a5b4fc",
    "variable": "var(--wa-colors-indigo-300)"
  },
  "colors.indigo.400": {
    "value": "#818cf8",
    "variable": "var(--wa-colors-indigo-400)"
  },
  "colors.indigo.500": {
    "value": "#6366f1",
    "variable": "var(--wa-colors-indigo-500)"
  },
  "colors.indigo.600": {
    "value": "#4f46e5",
    "variable": "var(--wa-colors-indigo-600)"
  },
  "colors.indigo.700": {
    "value": "#4338ca",
    "variable": "var(--wa-colors-indigo-700)"
  },
  "colors.indigo.800": {
    "value": "#3730a3",
    "variable": "var(--wa-colors-indigo-800)"
  },
  "colors.indigo.900": {
    "value": "#312e81",
    "variable": "var(--wa-colors-indigo-900)"
  },
  "colors.indigo.950": {
    "value": "#1e1b4b",
    "variable": "var(--wa-colors-indigo-950)"
  },
  "colors.sky.50": {
    "value": "#f0f9ff",
    "variable": "var(--wa-colors-sky-50)"
  },
  "colors.sky.100": {
    "value": "#e0f2fe",
    "variable": "var(--wa-colors-sky-100)"
  },
  "colors.sky.200": {
    "value": "#bae6fd",
    "variable": "var(--wa-colors-sky-200)"
  },
  "colors.sky.300": {
    "value": "#7dd3fc",
    "variable": "var(--wa-colors-sky-300)"
  },
  "colors.sky.400": {
    "value": "#38bdf8",
    "variable": "var(--wa-colors-sky-400)"
  },
  "colors.sky.500": {
    "value": "#0ea5e9",
    "variable": "var(--wa-colors-sky-500)"
  },
  "colors.sky.600": {
    "value": "#0284c7",
    "variable": "var(--wa-colors-sky-600)"
  },
  "colors.sky.700": {
    "value": "#0369a1",
    "variable": "var(--wa-colors-sky-700)"
  },
  "colors.sky.800": {
    "value": "#075985",
    "variable": "var(--wa-colors-sky-800)"
  },
  "colors.sky.900": {
    "value": "#0c4a6e",
    "variable": "var(--wa-colors-sky-900)"
  },
  "colors.sky.950": {
    "value": "#082f49",
    "variable": "var(--wa-colors-sky-950)"
  },
  "colors.cyan.50": {
    "value": "#ecfeff",
    "variable": "var(--wa-colors-cyan-50)"
  },
  "colors.cyan.100": {
    "value": "#cffafe",
    "variable": "var(--wa-colors-cyan-100)"
  },
  "colors.cyan.200": {
    "value": "#a5f3fc",
    "variable": "var(--wa-colors-cyan-200)"
  },
  "colors.cyan.300": {
    "value": "#67e8f9",
    "variable": "var(--wa-colors-cyan-300)"
  },
  "colors.cyan.400": {
    "value": "#22d3ee",
    "variable": "var(--wa-colors-cyan-400)"
  },
  "colors.cyan.500": {
    "value": "#06b6d4",
    "variable": "var(--wa-colors-cyan-500)"
  },
  "colors.cyan.600": {
    "value": "#0891b2",
    "variable": "var(--wa-colors-cyan-600)"
  },
  "colors.cyan.700": {
    "value": "#0e7490",
    "variable": "var(--wa-colors-cyan-700)"
  },
  "colors.cyan.800": {
    "value": "#155e75",
    "variable": "var(--wa-colors-cyan-800)"
  },
  "colors.cyan.900": {
    "value": "#164e63",
    "variable": "var(--wa-colors-cyan-900)"
  },
  "colors.cyan.950": {
    "value": "#083344",
    "variable": "var(--wa-colors-cyan-950)"
  },
  "colors.teal.50": {
    "value": "#f0fdfa",
    "variable": "var(--wa-colors-teal-50)"
  },
  "colors.teal.100": {
    "value": "#ccfbf1",
    "variable": "var(--wa-colors-teal-100)"
  },
  "colors.teal.200": {
    "value": "#99f6e4",
    "variable": "var(--wa-colors-teal-200)"
  },
  "colors.teal.300": {
    "value": "#5eead4",
    "variable": "var(--wa-colors-teal-300)"
  },
  "colors.teal.400": {
    "value": "#2dd4bf",
    "variable": "var(--wa-colors-teal-400)"
  },
  "colors.teal.500": {
    "value": "#14b8a6",
    "variable": "var(--wa-colors-teal-500)"
  },
  "colors.teal.600": {
    "value": "#0d9488",
    "variable": "var(--wa-colors-teal-600)"
  },
  "colors.teal.700": {
    "value": "#0f766e",
    "variable": "var(--wa-colors-teal-700)"
  },
  "colors.teal.800": {
    "value": "#115e59",
    "variable": "var(--wa-colors-teal-800)"
  },
  "colors.teal.900": {
    "value": "#134e4a",
    "variable": "var(--wa-colors-teal-900)"
  },
  "colors.teal.950": {
    "value": "#042f2e",
    "variable": "var(--wa-colors-teal-950)"
  },
  "colors.emerald.50": {
    "value": "#ecfdf5",
    "variable": "var(--wa-colors-emerald-50)"
  },
  "colors.emerald.100": {
    "value": "#d1fae5",
    "variable": "var(--wa-colors-emerald-100)"
  },
  "colors.emerald.200": {
    "value": "#a7f3d0",
    "variable": "var(--wa-colors-emerald-200)"
  },
  "colors.emerald.300": {
    "value": "#6ee7b7",
    "variable": "var(--wa-colors-emerald-300)"
  },
  "colors.emerald.400": {
    "value": "#34d399",
    "variable": "var(--wa-colors-emerald-400)"
  },
  "colors.emerald.500": {
    "value": "#10b981",
    "variable": "var(--wa-colors-emerald-500)"
  },
  "colors.emerald.600": {
    "value": "#059669",
    "variable": "var(--wa-colors-emerald-600)"
  },
  "colors.emerald.700": {
    "value": "#047857",
    "variable": "var(--wa-colors-emerald-700)"
  },
  "colors.emerald.800": {
    "value": "#065f46",
    "variable": "var(--wa-colors-emerald-800)"
  },
  "colors.emerald.900": {
    "value": "#064e3b",
    "variable": "var(--wa-colors-emerald-900)"
  },
  "colors.emerald.950": {
    "value": "#022c22",
    "variable": "var(--wa-colors-emerald-950)"
  },
  "colors.lime.50": {
    "value": "#f7fee7",
    "variable": "var(--wa-colors-lime-50)"
  },
  "colors.lime.100": {
    "value": "#ecfccb",
    "variable": "var(--wa-colors-lime-100)"
  },
  "colors.lime.200": {
    "value": "#d9f99d",
    "variable": "var(--wa-colors-lime-200)"
  },
  "colors.lime.300": {
    "value": "#bef264",
    "variable": "var(--wa-colors-lime-300)"
  },
  "colors.lime.400": {
    "value": "#a3e635",
    "variable": "var(--wa-colors-lime-400)"
  },
  "colors.lime.500": {
    "value": "#84cc16",
    "variable": "var(--wa-colors-lime-500)"
  },
  "colors.lime.600": {
    "value": "#65a30d",
    "variable": "var(--wa-colors-lime-600)"
  },
  "colors.lime.700": {
    "value": "#4d7c0f",
    "variable": "var(--wa-colors-lime-700)"
  },
  "colors.lime.800": {
    "value": "#3f6212",
    "variable": "var(--wa-colors-lime-800)"
  },
  "colors.lime.900": {
    "value": "#365314",
    "variable": "var(--wa-colors-lime-900)"
  },
  "colors.lime.950": {
    "value": "#1a2e05",
    "variable": "var(--wa-colors-lime-950)"
  },
  "colors.amber.50": {
    "value": "#fffbeb",
    "variable": "var(--wa-colors-amber-50)"
  },
  "colors.amber.100": {
    "value": "#fef3c7",
    "variable": "var(--wa-colors-amber-100)"
  },
  "colors.amber.200": {
    "value": "#fde68a",
    "variable": "var(--wa-colors-amber-200)"
  },
  "colors.amber.300": {
    "value": "#fcd34d",
    "variable": "var(--wa-colors-amber-300)"
  },
  "colors.amber.400": {
    "value": "#fbbf24",
    "variable": "var(--wa-colors-amber-400)"
  },
  "colors.amber.500": {
    "value": "#f59e0b",
    "variable": "var(--wa-colors-amber-500)"
  },
  "colors.amber.600": {
    "value": "#d97706",
    "variable": "var(--wa-colors-amber-600)"
  },
  "colors.amber.700": {
    "value": "#b45309",
    "variable": "var(--wa-colors-amber-700)"
  },
  "colors.amber.800": {
    "value": "#92400e",
    "variable": "var(--wa-colors-amber-800)"
  },
  "colors.amber.900": {
    "value": "#78350f",
    "variable": "var(--wa-colors-amber-900)"
  },
  "colors.amber.950": {
    "value": "#451a03",
    "variable": "var(--wa-colors-amber-950)"
  },
  "colors.neutral.50": {
    "value": "#fafafa",
    "variable": "var(--wa-colors-neutral-50)"
  },
  "colors.neutral.100": {
    "value": "#f5f5f5",
    "variable": "var(--wa-colors-neutral-100)"
  },
  "colors.neutral.200": {
    "value": "#e5e5e5",
    "variable": "var(--wa-colors-neutral-200)"
  },
  "colors.neutral.300": {
    "value": "#d4d4d4",
    "variable": "var(--wa-colors-neutral-300)"
  },
  "colors.neutral.400": {
    "value": "#a3a3a3",
    "variable": "var(--wa-colors-neutral-400)"
  },
  "colors.neutral.500": {
    "value": "#737373",
    "variable": "var(--wa-colors-neutral-500)"
  },
  "colors.neutral.600": {
    "value": "#525252",
    "variable": "var(--wa-colors-neutral-600)"
  },
  "colors.neutral.700": {
    "value": "#404040",
    "variable": "var(--wa-colors-neutral-700)"
  },
  "colors.neutral.800": {
    "value": "#262626",
    "variable": "var(--wa-colors-neutral-800)"
  },
  "colors.neutral.900": {
    "value": "#171717",
    "variable": "var(--wa-colors-neutral-900)"
  },
  "colors.neutral.950": {
    "value": "#0a0a0a",
    "variable": "var(--wa-colors-neutral-950)"
  },
  "colors.stone.50": {
    "value": "#fafaf9",
    "variable": "var(--wa-colors-stone-50)"
  },
  "colors.stone.100": {
    "value": "#f5f5f4",
    "variable": "var(--wa-colors-stone-100)"
  },
  "colors.stone.200": {
    "value": "#e7e5e4",
    "variable": "var(--wa-colors-stone-200)"
  },
  "colors.stone.300": {
    "value": "#d6d3d1",
    "variable": "var(--wa-colors-stone-300)"
  },
  "colors.stone.400": {
    "value": "#a8a29e",
    "variable": "var(--wa-colors-stone-400)"
  },
  "colors.stone.500": {
    "value": "#78716c",
    "variable": "var(--wa-colors-stone-500)"
  },
  "colors.stone.600": {
    "value": "#57534e",
    "variable": "var(--wa-colors-stone-600)"
  },
  "colors.stone.700": {
    "value": "#44403c",
    "variable": "var(--wa-colors-stone-700)"
  },
  "colors.stone.800": {
    "value": "#292524",
    "variable": "var(--wa-colors-stone-800)"
  },
  "colors.stone.900": {
    "value": "#1c1917",
    "variable": "var(--wa-colors-stone-900)"
  },
  "colors.stone.950": {
    "value": "#0c0a09",
    "variable": "var(--wa-colors-stone-950)"
  },
  "colors.zinc.50": {
    "value": "#fafafa",
    "variable": "var(--wa-colors-zinc-50)"
  },
  "colors.zinc.100": {
    "value": "#f4f4f5",
    "variable": "var(--wa-colors-zinc-100)"
  },
  "colors.zinc.200": {
    "value": "#e4e4e7",
    "variable": "var(--wa-colors-zinc-200)"
  },
  "colors.zinc.300": {
    "value": "#d4d4d8",
    "variable": "var(--wa-colors-zinc-300)"
  },
  "colors.zinc.400": {
    "value": "#a1a1aa",
    "variable": "var(--wa-colors-zinc-400)"
  },
  "colors.zinc.500": {
    "value": "#71717a",
    "variable": "var(--wa-colors-zinc-500)"
  },
  "colors.zinc.600": {
    "value": "#52525b",
    "variable": "var(--wa-colors-zinc-600)"
  },
  "colors.zinc.700": {
    "value": "#3f3f46",
    "variable": "var(--wa-colors-zinc-700)"
  },
  "colors.zinc.800": {
    "value": "#27272a",
    "variable": "var(--wa-colors-zinc-800)"
  },
  "colors.zinc.900": {
    "value": "#18181b",
    "variable": "var(--wa-colors-zinc-900)"
  },
  "colors.zinc.950": {
    "value": "#09090b",
    "variable": "var(--wa-colors-zinc-950)"
  },
  "colors.gray.50": {
    "value": "#f9fafb",
    "variable": "var(--wa-colors-gray-50)"
  },
  "colors.gray.100": {
    "value": "#f3f4f6",
    "variable": "var(--wa-colors-gray-100)"
  },
  "colors.gray.200": {
    "value": "#e5e7eb",
    "variable": "var(--wa-colors-gray-200)"
  },
  "colors.gray.300": {
    "value": "#d1d5db",
    "variable": "var(--wa-colors-gray-300)"
  },
  "colors.gray.400": {
    "value": "#9ca3af",
    "variable": "var(--wa-colors-gray-400)"
  },
  "colors.gray.500": {
    "value": "#6b7280",
    "variable": "var(--wa-colors-gray-500)"
  },
  "colors.gray.600": {
    "value": "#4b5563",
    "variable": "var(--wa-colors-gray-600)"
  },
  "colors.gray.700": {
    "value": "#374151",
    "variable": "var(--wa-colors-gray-700)"
  },
  "colors.gray.800": {
    "value": "#1f2937",
    "variable": "var(--wa-colors-gray-800)"
  },
  "colors.gray.900": {
    "value": "#111827",
    "variable": "var(--wa-colors-gray-900)"
  },
  "colors.gray.950": {
    "value": "#030712",
    "variable": "var(--wa-colors-gray-950)"
  },
  "colors.slate.50": {
    "value": "#f8fafc",
    "variable": "var(--wa-colors-slate-50)"
  },
  "colors.slate.100": {
    "value": "#f1f5f9",
    "variable": "var(--wa-colors-slate-100)"
  },
  "colors.slate.200": {
    "value": "#e2e8f0",
    "variable": "var(--wa-colors-slate-200)"
  },
  "colors.slate.300": {
    "value": "#cbd5e1",
    "variable": "var(--wa-colors-slate-300)"
  },
  "colors.slate.400": {
    "value": "#94a3b8",
    "variable": "var(--wa-colors-slate-400)"
  },
  "colors.slate.500": {
    "value": "#64748b",
    "variable": "var(--wa-colors-slate-500)"
  },
  "colors.slate.600": {
    "value": "#475569",
    "variable": "var(--wa-colors-slate-600)"
  },
  "colors.slate.700": {
    "value": "#334155",
    "variable": "var(--wa-colors-slate-700)"
  },
  "colors.slate.800": {
    "value": "#1e293b",
    "variable": "var(--wa-colors-slate-800)"
  },
  "colors.slate.900": {
    "value": "#0f172a",
    "variable": "var(--wa-colors-slate-900)"
  },
  "colors.slate.950": {
    "value": "#020617",
    "variable": "var(--wa-colors-slate-950)"
  },
  "colors.ink.0": {
    "value": "#FFFFFF",
    "variable": "var(--wa-colors-ink-0)"
  },
  "colors.ink.100": {
    "value": "#FAFAFA",
    "variable": "var(--wa-colors-ink-100)"
  },
  "colors.ink.200": {
    "value": "#F4F4F5",
    "variable": "var(--wa-colors-ink-200)"
  },
  "colors.ink.300": {
    "value": "#EDEDEE",
    "variable": "var(--wa-colors-ink-300)"
  },
  "colors.ink.400": {
    "value": "#D4D4D8",
    "variable": "var(--wa-colors-ink-400)"
  },
  "colors.ink.500": {
    "value": "#B8B8C1",
    "variable": "var(--wa-colors-ink-500)"
  },
  "colors.ink.600": {
    "value": "#94949F",
    "variable": "var(--wa-colors-ink-600)"
  },
  "colors.ink.700": {
    "value": "#747480",
    "variable": "var(--wa-colors-ink-700)"
  },
  "colors.ink.800": {
    "value": "#585861",
    "variable": "var(--wa-colors-ink-800)"
  },
  "colors.ink.900": {
    "value": "#414149",
    "variable": "var(--wa-colors-ink-900)"
  },
  "colors.ink.1000": {
    "value": "#27272A",
    "variable": "var(--wa-colors-ink-1000)"
  },
  "colors.red.50": {
    "value": "#fef2f2",
    "variable": "var(--wa-colors-red-50)"
  },
  "colors.red.100": {
    "value": "#FFECEB",
    "variable": "var(--wa-colors-red-100)"
  },
  "colors.red.200": {
    "value": "#FFD5D2",
    "variable": "var(--wa-colors-red-200)"
  },
  "colors.red.300": {
    "value": "#FD9891",
    "variable": "var(--wa-colors-red-300)"
  },
  "colors.red.400": {
    "value": "#F87168",
    "variable": "var(--wa-colors-red-400)"
  },
  "colors.red.500": {
    "value": "#F15B50",
    "variable": "var(--wa-colors-red-500)"
  },
  "colors.red.600": {
    "value": "#E2483D",
    "variable": "var(--wa-colors-red-600)"
  },
  "colors.red.700": {
    "value": "#C9372C",
    "variable": "var(--wa-colors-red-700)"
  },
  "colors.red.800": {
    "value": "#AE2E24",
    "variable": "var(--wa-colors-red-800)"
  },
  "colors.red.900": {
    "value": "#5D1F1A",
    "variable": "var(--wa-colors-red-900)"
  },
  "colors.red.950": {
    "value": "#450a0a",
    "variable": "var(--wa-colors-red-950)"
  },
  "colors.red.1000": {
    "value": "#42221F",
    "variable": "var(--wa-colors-red-1000)"
  },
  "colors.orange.50": {
    "value": "#fff7ed",
    "variable": "var(--wa-colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "#FFF3EB",
    "variable": "var(--wa-colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "#FEDEC8",
    "variable": "var(--wa-colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "#FEC195",
    "variable": "var(--wa-colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "#FEA362",
    "variable": "var(--wa-colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "#F38A3F",
    "variable": "var(--wa-colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "#E56910",
    "variable": "var(--wa-colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "#C25100",
    "variable": "var(--wa-colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "#A54800",
    "variable": "var(--wa-colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "#702E00",
    "variable": "var(--wa-colors-orange-900)"
  },
  "colors.orange.950": {
    "value": "#431407",
    "variable": "var(--wa-colors-orange-950)"
  },
  "colors.orange.1000": {
    "value": "#38291E",
    "variable": "var(--wa-colors-orange-1000)"
  },
  "colors.yellow.50": {
    "value": "#fefce8",
    "variable": "var(--wa-colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#FFF7D6",
    "variable": "var(--wa-colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#F8E6A0",
    "variable": "var(--wa-colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#F5CD47",
    "variable": "var(--wa-colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#E2B203",
    "variable": "var(--wa-colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#CF9F02",
    "variable": "var(--wa-colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#B38600",
    "variable": "var(--wa-colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#946F00",
    "variable": "var(--wa-colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#7F5F01",
    "variable": "var(--wa-colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#533F04",
    "variable": "var(--wa-colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "#422006",
    "variable": "var(--wa-colors-yellow-950)"
  },
  "colors.yellow.1000": {
    "value": "#332E1B",
    "variable": "var(--wa-colors-yellow-1000)"
  },
  "colors.magenta.100": {
    "value": "#FFECF8",
    "variable": "var(--wa-colors-magenta-100)"
  },
  "colors.magenta.200": {
    "value": "#FDD0EC",
    "variable": "var(--wa-colors-magenta-200)"
  },
  "colors.magenta.300": {
    "value": "#F797D2",
    "variable": "var(--wa-colors-magenta-300)"
  },
  "colors.magenta.400": {
    "value": "#E774BB",
    "variable": "var(--wa-colors-magenta-400)"
  },
  "colors.magenta.500": {
    "value": "#DA62AC",
    "variable": "var(--wa-colors-magenta-500)"
  },
  "colors.magenta.600": {
    "value": "#CD519D",
    "variable": "var(--wa-colors-magenta-600)"
  },
  "colors.magenta.700": {
    "value": "#AE4787",
    "variable": "var(--wa-colors-magenta-700)"
  },
  "colors.magenta.800": {
    "value": "#943D73",
    "variable": "var(--wa-colors-magenta-800)"
  },
  "colors.magenta.900": {
    "value": "#50253F",
    "variable": "var(--wa-colors-magenta-900)"
  },
  "colors.magenta.1000": {
    "value": "#3D2232",
    "variable": "var(--wa-colors-magenta-1000)"
  },
  "colors.purple.50": {
    "value": "#faf5ff",
    "variable": "var(--wa-colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "#F3F0FF",
    "variable": "var(--wa-colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "#DFD8FD",
    "variable": "var(--wa-colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "#B8ACF6",
    "variable": "var(--wa-colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "#9F8FEF",
    "variable": "var(--wa-colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "#8F7EE7",
    "variable": "var(--wa-colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "#8270DB",
    "variable": "var(--wa-colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "#6E5DC6",
    "variable": "var(--wa-colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "#5E4DB2",
    "variable": "var(--wa-colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "#352C63",
    "variable": "var(--wa-colors-purple-900)"
  },
  "colors.purple.950": {
    "value": "#3b0764",
    "variable": "var(--wa-colors-purple-950)"
  },
  "colors.purple.1000": {
    "value": "#2B273F",
    "variable": "var(--wa-colors-purple-1000)"
  },
  "colors.green.50": {
    "value": "#f0fdf4",
    "variable": "var(--wa-colors-green-50)"
  },
  "colors.green.100": {
    "value": "#DDF3F1",
    "variable": "var(--wa-colors-green-100)"
  },
  "colors.green.200": {
    "value": "#C5EAE6",
    "variable": "var(--wa-colors-green-200)"
  },
  "colors.green.300": {
    "value": "#98DCD5",
    "variable": "var(--wa-colors-green-300)"
  },
  "colors.green.400": {
    "value": "#61D0C6",
    "variable": "var(--wa-colors-green-400)"
  },
  "colors.green.500": {
    "value": "#30C1B3",
    "variable": "var(--wa-colors-green-500)"
  },
  "colors.green.600": {
    "value": "#26A69A",
    "variable": "var(--wa-colors-green-600)"
  },
  "colors.green.700": {
    "value": "#1E9187",
    "variable": "var(--wa-colors-green-700)"
  },
  "colors.green.800": {
    "value": "#117C72",
    "variable": "var(--wa-colors-green-800)"
  },
  "colors.green.900": {
    "value": "#095A52",
    "variable": "var(--wa-colors-green-900)"
  },
  "colors.green.950": {
    "value": "#052e16",
    "variable": "var(--wa-colors-green-950)"
  },
  "colors.green.1000": {
    "value": "#033531",
    "variable": "var(--wa-colors-green-1000)"
  },
  "colors.blue.50": {
    "value": "#eff6ff",
    "variable": "var(--wa-colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "#E3F1FF",
    "variable": "var(--wa-colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "#C0E0FF",
    "variable": "var(--wa-colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "#89C4FF",
    "variable": "var(--wa-colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "#5BAAF8",
    "variable": "var(--wa-colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "#3C94EB",
    "variable": "var(--wa-colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "#2383E2",
    "variable": "var(--wa-colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "#1876D3",
    "variable": "var(--wa-colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "#0D66BE",
    "variable": "var(--wa-colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "#0153A4",
    "variable": "var(--wa-colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "#172554",
    "variable": "var(--wa-colors-blue-950)"
  },
  "colors.blue.1000": {
    "value": "#003264",
    "variable": "var(--wa-colors-blue-1000)"
  },
  "colors.cream.100": {
    "value": "#FFFDFB",
    "variable": "var(--wa-colors-cream-100)"
  },
  "colors.cream.200": {
    "value": "#FAF7F3",
    "variable": "var(--wa-colors-cream-200)"
  },
  "colors.cream.300": {
    "value": "#F1EDE7",
    "variable": "var(--wa-colors-cream-300)"
  },
  "colors.cream.400": {
    "value": "#DEDAD3",
    "variable": "var(--wa-colors-cream-400)"
  },
  "colors.cream.500": {
    "value": "#CAC5BE",
    "variable": "var(--wa-colors-cream-500)"
  },
  "colors.cream.600": {
    "value": "#ACA498",
    "variable": "var(--wa-colors-cream-600)"
  },
  "colors.cream.700": {
    "value": "#857D72",
    "variable": "var(--wa-colors-cream-700)"
  },
  "colors.cream.800": {
    "value": "#5C574D",
    "variable": "var(--wa-colors-cream-800)"
  },
  "colors.cream.900": {
    "value": "#434039",
    "variable": "var(--wa-colors-cream-900)"
  },
  "colors.cream.1000": {
    "value": "#2C2821",
    "variable": "var(--wa-colors-cream-1000)"
  },
  "radii.0": {
    "value": "0",
    "variable": "var(--wa-radii-0)"
  },
  "radii.25": {
    "value": "0.125rem",
    "variable": "var(--wa-radii-25)"
  },
  "radii.50": {
    "value": "0.25rem",
    "variable": "var(--wa-radii-50)"
  },
  "radii.75": {
    "value": "0.375rem",
    "variable": "var(--wa-radii-75)"
  },
  "radii.100": {
    "value": "0.5rem",
    "variable": "var(--wa-radii-100)"
  },
  "radii.150": {
    "value": "0.75rem",
    "variable": "var(--wa-radii-150)"
  },
  "radii.200": {
    "value": "1rem",
    "variable": "var(--wa-radii-200)"
  },
  "radii.250": {
    "value": "1.25rem",
    "variable": "var(--wa-radii-250)"
  },
  "radii.300": {
    "value": "1.5rem",
    "variable": "var(--wa-radii-300)"
  },
  "radii.400": {
    "value": "2rem",
    "variable": "var(--wa-radii-400)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--wa-radii-xs)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--wa-radii-sm)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--wa-radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--wa-radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--wa-radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--wa-radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--wa-radii-3xl)"
  },
  "radii.4xl": {
    "value": "2rem",
    "variable": "var(--wa-radii-4xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--wa-radii-full)"
  },
  "shadows.25": {
    "value": "0 0.7px 1px 0 rgba(197, 189, 181, 0.06), 0 1.1px 1.5px -0.4px rgba(197, 189, 181, 0.16), 0 2.1px 2.9px -0.7px rgba(197, 189, 181, 0.25);",
    "variable": "var(--wa-shadows-25)"
  },
  "shadows.50": {
    "value": "0 0.7px 1px 0 rgba(197, 189, 181, 0.06), 0 1.6px 2.2px -0.3px rgba(197, 189, 181, 0.20), 0 2.6px 4px -0.8px rgba(197, 189, 181, 0.28);",
    "variable": "var(--wa-shadows-50)"
  },
  "shadows.100": {
    "value": "0 0.7px 1px 0 rgba(197, 189, 181, 0.06), 0 2px 2.7px -0.2px rgba(197, 189, 181, 0.14), 0 2.6px 6px -0.4px rgba(197, 189, 181, 0.22), 0 4px 10px -0.8px rgba(197, 189, 181, 0.30);",
    "variable": "var(--wa-shadows-100)"
  },
  "shadows.200": {
    "value": "0 0.7px 1px 0 rgba(197, 189, 181, 0.06), 0 2.9px 3.9px -0.2px rgba(197, 189, 181, 0.14), 0 5px 8.2px -0.4px rgba(197, 189, 181, 0.22), 0 6.3px 14px -0.8px rgba(197, 189, 181, 0.30);",
    "variable": "var(--wa-shadows-200)"
  },
  "shadows.300": {
    "value": "0 0.7px 1px 0 rgba(197, 189, 181, 0.06), 0 3.4px 4.9px -0.2px rgba(197, 189, 181, 0.14), 0 6.8px 10.7px -0.4px rgba(197, 189, 181, 0.16), 0 11px 16px -0.5px rgba(197, 189, 181, 0.32), 0 17px 24px -0.6px rgba(197, 189, 181, 0.18);",
    "variable": "var(--wa-shadows-300)"
  },
  "shadows.400": {
    "value": "0 0.7px 1px 0 rgba(197, 189, 181, 0.06), 0 4.3px 7.7px -0.2px rgba(197, 189, 181, 0.14), 0 6.8px 10.7px -0.4px rgba(197, 189, 181, 0.16), 0 11px 16px -0.5px rgba(197, 189, 181, 0.32), 0 17px 24px -0.4px rgba(197, 189, 181, 0.26), 0 21px 34px -0.8px rgba(197, 189, 181, 0.22);",
    "variable": "var(--wa-shadows-400)"
  },
  "shadows.xs": {
    "value": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--wa-shadows-xs)"
  },
  "shadows.sm": {
    "value": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    "variable": "var(--wa-shadows-sm)"
  },
  "shadows.md": {
    "value": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    "variable": "var(--wa-shadows-md)"
  },
  "shadows.lg": {
    "value": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    "variable": "var(--wa-shadows-lg)"
  },
  "shadows.xl": {
    "value": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "variable": "var(--wa-shadows-xl)"
  },
  "shadows.2xl": {
    "value": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    "variable": "var(--wa-shadows-2xl)"
  },
  "shadows.inner": {
    "value": "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--wa-shadows-inner)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--wa-sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--wa-sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--wa-sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--wa-sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--wa-sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--wa-sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--wa-sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--wa-sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--wa-sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--wa-sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--wa-sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--wa-sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--wa-sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--wa-sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--wa-sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--wa-sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--wa-sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--wa-sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--wa-sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--wa-sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--wa-sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--wa-sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--wa-sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--wa-sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--wa-sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--wa-sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--wa-sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--wa-sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--wa-sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--wa-sizes-96)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--wa-sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--wa-sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--wa-sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--wa-sizes-3\\.5)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--wa-sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--wa-sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--wa-sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--wa-sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--wa-sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--wa-sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--wa-sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--wa-sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--wa-sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--wa-sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--wa-sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--wa-sizes-8xl)"
  },
  "sizes.prose": {
    "value": "65ch",
    "variable": "var(--wa-sizes-prose)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--wa-sizes-full)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--wa-sizes-min)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--wa-sizes-max)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--wa-sizes-fit)"
  },
  "sizes.icons.sm": {
    "value": "1rem",
    "variable": "var(--wa-sizes-icons-sm)"
  },
  "sizes.icons.md": {
    "value": "1.25rem",
    "variable": "var(--wa-sizes-icons-md)"
  },
  "sizes.icons.lg": {
    "value": "1.5rem",
    "variable": "var(--wa-sizes-icons-lg)"
  },
  "sizes.icons.xl": {
    "value": "2rem",
    "variable": "var(--wa-sizes-icons-xl)"
  },
  "sizes.modals.pane": {
    "value": "460px",
    "variable": "var(--wa-sizes-modals-pane)"
  },
  "sizes.modals.largePane": {
    "value": "520px",
    "variable": "var(--wa-sizes-modals-large-pane)"
  },
  "sizes.modals.center": {
    "value": "400px",
    "variable": "var(--wa-sizes-modals-center)"
  },
  "sizes.modals.full": {
    "value": "95vw",
    "variable": "var(--wa-sizes-modals-full)"
  },
  "sizes.breakpoint-sm": {
    "value": "640px",
    "variable": "var(--wa-sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--wa-sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--wa-sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1280px",
    "variable": "var(--wa-sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--wa-sizes-breakpoint-2xl)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--wa-spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--wa-spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--wa-spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--wa-spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--wa-spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--wa-spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--wa-spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--wa-spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--wa-spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--wa-spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--wa-spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--wa-spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--wa-spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--wa-spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--wa-spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--wa-spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--wa-spacing-24)"
  },
  "spacing.25": {
    "value": "0.125rem",
    "variable": "var(--wa-spacing-25)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--wa-spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--wa-spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--wa-spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--wa-spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--wa-spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--wa-spacing-48)"
  },
  "spacing.50": {
    "value": "0.25rem",
    "variable": "var(--wa-spacing-50)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--wa-spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--wa-spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--wa-spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--wa-spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--wa-spacing-72)"
  },
  "spacing.75": {
    "value": "0.375rem",
    "variable": "var(--wa-spacing-75)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--wa-spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--wa-spacing-96)"
  },
  "spacing.100": {
    "value": "0.5rem",
    "variable": "var(--wa-spacing-100)"
  },
  "spacing.150": {
    "value": "0.75rem",
    "variable": "var(--wa-spacing-150)"
  },
  "spacing.200": {
    "value": "1rem",
    "variable": "var(--wa-spacing-200)"
  },
  "spacing.250": {
    "value": "1.25rem",
    "variable": "var(--wa-spacing-250)"
  },
  "spacing.300": {
    "value": "1.5rem",
    "variable": "var(--wa-spacing-300)"
  },
  "spacing.400": {
    "value": "2rem",
    "variable": "var(--wa-spacing-400)"
  },
  "spacing.500": {
    "value": "2.5rem",
    "variable": "var(--wa-spacing-500)"
  },
  "spacing.600": {
    "value": "3rem",
    "variable": "var(--wa-spacing-600)"
  },
  "spacing.800": {
    "value": "4rem",
    "variable": "var(--wa-spacing-800)"
  },
  "spacing.1000": {
    "value": "5rem",
    "variable": "var(--wa-spacing-1000)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--wa-spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--wa-spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--wa-spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--wa-spacing-3\\.5)"
  },
  "zIndex.toast": {
    "value": 2147483647,
    "variable": "var(--wa-z-index-toast)"
  },
  "zIndex.max": {
    "value": 2147483647,
    "variable": "var(--wa-z-index-max)"
  },
  "zIndex.modal": {
    "value": 2147483646,
    "variable": "var(--wa-z-index-modal)"
  },
  "zIndex.tooltip": {
    "value": 2147483647,
    "variable": "var(--wa-z-index-tooltip)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--wa-easings-default)"
  },
  "easings.linear": {
    "value": "linear",
    "variable": "var(--wa-easings-linear)"
  },
  "easings.in": {
    "value": "cubic-bezier(0.4, 0, 1, 1)",
    "variable": "var(--wa-easings-in)"
  },
  "easings.out": {
    "value": "cubic-bezier(0, 0, 0.2, 1)",
    "variable": "var(--wa-easings-out)"
  },
  "easings.in-out": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--wa-easings-in-out)"
  },
  "easings.standard.productive": {
    "value": "cubic-bezier(0.2, 0, 0.38, 0.9)",
    "variable": "var(--wa-easings-standard-productive)"
  },
  "easings.standard.expressive": {
    "value": "cubic-bezier(0.4, 0.14, 0.3, 1)",
    "variable": "var(--wa-easings-standard-expressive)"
  },
  "easings.entrance.productive": {
    "value": "cubic-bezier(0, 0, 0.38, 0.9)",
    "variable": "var(--wa-easings-entrance-productive)"
  },
  "easings.entrance.expressive": {
    "value": "cubic-bezier(0, 0, 0.3, 1)",
    "variable": "var(--wa-easings-entrance-expressive)"
  },
  "easings.exit.productive": {
    "value": "cubic-bezier(0.2, 0, 1, 0.9)",
    "variable": "var(--wa-easings-exit-productive)"
  },
  "easings.exit.expressive": {
    "value": "cubic-bezier(0.4, 0.14, 1, 1)",
    "variable": "var(--wa-easings-exit-expressive)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--wa-durations-fastest)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--wa-durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--wa-durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--wa-durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--wa-durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--wa-durations-slower)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--wa-durations-slowest)"
  },
  "durations.fast1": {
    "value": "70ms",
    "variable": "var(--wa-durations-fast1)"
  },
  "durations.fast2": {
    "value": "110ms",
    "variable": "var(--wa-durations-fast2)"
  },
  "durations.moderate1": {
    "value": "150ms",
    "variable": "var(--wa-durations-moderate1)"
  },
  "durations.moderate2": {
    "value": "240ms",
    "variable": "var(--wa-durations-moderate2)"
  },
  "durations.slow1": {
    "value": "400ms",
    "variable": "var(--wa-durations-slow1)"
  },
  "durations.slow2": {
    "value": "700ms",
    "variable": "var(--wa-durations-slow2)"
  },
  "letterSpacings.tightest": {
    "value": "-0.01em",
    "variable": "var(--wa-letter-spacings-tightest)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--wa-letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--wa-letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0",
    "variable": "var(--wa-letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.008em",
    "variable": "var(--wa-letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.024em",
    "variable": "var(--wa-letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--wa-letter-spacings-widest)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--wa-line-heights-none)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--wa-line-heights-tight)"
  },
  "lineHeights.snug": {
    "value": "1.375",
    "variable": "var(--wa-line-heights-snug)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--wa-line-heights-normal)"
  },
  "lineHeights.relaxed": {
    "value": "1.625",
    "variable": "var(--wa-line-heights-relaxed)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--wa-line-heights-loose)"
  },
  "lineHeights.3xs": {
    "value": "1rem",
    "variable": "var(--wa-line-heights-3xs)"
  },
  "lineHeights.2xs": {
    "value": "1.125rem",
    "variable": "var(--wa-line-heights-2xs)"
  },
  "lineHeights.xs": {
    "value": "1.375rem",
    "variable": "var(--wa-line-heights-xs)"
  },
  "lineHeights.sm": {
    "value": "1.5rem",
    "variable": "var(--wa-line-heights-sm)"
  },
  "lineHeights.md": {
    "value": "1.75rem",
    "variable": "var(--wa-line-heights-md)"
  },
  "lineHeights.lg": {
    "value": "2rem",
    "variable": "var(--wa-line-heights-lg)"
  },
  "lineHeights.xl": {
    "value": "2.25rem",
    "variable": "var(--wa-line-heights-xl)"
  },
  "lineHeights.2xl": {
    "value": "2.5rem",
    "variable": "var(--wa-line-heights-2xl)"
  },
  "lineHeights.3xl": {
    "value": "3rem",
    "variable": "var(--wa-line-heights-3xl)"
  },
  "lineHeights.4xl": {
    "value": "3.75rem",
    "variable": "var(--wa-line-heights-4xl)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--wa-font-weights-extralight)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--wa-font-weights-semibold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--wa-font-weights-extrabold)"
  },
  "fontWeights.thin": {
    "value": 200,
    "variable": "var(--wa-font-weights-thin)"
  },
  "fontWeights.light": {
    "value": 300,
    "variable": "var(--wa-font-weights-light)"
  },
  "fontWeights.normal": {
    "value": 400,
    "variable": "var(--wa-font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": 500,
    "variable": "var(--wa-font-weights-medium)"
  },
  "fontWeights.semiBold": {
    "value": 600,
    "variable": "var(--wa-font-weights-semi-bold)"
  },
  "fontWeights.bold": {
    "value": 700,
    "variable": "var(--wa-font-weights-bold)"
  },
  "fontWeights.extraBold": {
    "value": 800,
    "variable": "var(--wa-font-weights-extra-bold)"
  },
  "fontWeights.black": {
    "value": 900,
    "variable": "var(--wa-font-weights-black)"
  },
  "fonts.sans": {
    "value": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--wa-fonts-sans)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--wa-fonts-serif)"
  },
  "fonts.heading": {
    "value": "\"Outfit\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
    "variable": "var(--wa-fonts-heading)"
  },
  "fonts.body": {
    "value": "\"Outfit\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
    "variable": "var(--wa-fonts-body)"
  },
  "fonts.mono": {
    "value": "\"IBM Plex Mono\", SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--wa-fonts-mono)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--wa-font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--wa-font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--wa-font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--wa-font-sizes-9xl)"
  },
  "fontSizes.3xs": {
    "value": "0.75rem",
    "variable": "var(--wa-font-sizes-3xs)"
  },
  "fontSizes.2xs": {
    "value": "0.813rem",
    "variable": "var(--wa-font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": "0.875rem",
    "variable": "var(--wa-font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.938rem",
    "variable": "var(--wa-font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--wa-font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--wa-font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--wa-font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--wa-font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "2rem",
    "variable": "var(--wa-font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--wa-font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--wa-font-sizes-5xl)"
  },
  "breakpoints.sm": {
    "value": "640px",
    "variable": "var(--wa-breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--wa-breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--wa-breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1280px",
    "variable": "var(--wa-breakpoints-xl)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--wa-breakpoints-2xl)"
  },
  "colors.text.dark": {
    "value": "var(--wa-colors-ink-1000)",
    "variable": "var(--wa-colors-text-dark)"
  },
  "colors.text.mid": {
    "value": "var(--wa-colors-ink-800)",
    "variable": "var(--wa-colors-text-mid)"
  },
  "colors.text.light": {
    "value": "var(--wa-colors-ink-600)",
    "variable": "var(--wa-colors-text-light)"
  },
  "colors.text.disabled": {
    "value": "var(--wa-colors-ink-400)",
    "variable": "var(--wa-colors-text-disabled)"
  },
  "colors.text.inverse": {
    "value": "white",
    "variable": "var(--wa-colors-text-inverse)"
  },
  "colors.text.accent.blue.dark": {
    "value": "var(--wa-colors-blue-800)",
    "variable": "var(--wa-colors-text-accent-blue-dark)"
  },
  "colors.text.accent.blue.mid": {
    "value": "var(--wa-colors-blue-600)",
    "variable": "var(--wa-colors-text-accent-blue-mid)"
  },
  "colors.text.accent.blue.light": {
    "value": "var(--wa-colors-blue-400)",
    "variable": "var(--wa-colors-text-accent-blue-light)"
  },
  "colors.text.accent.purple.dark": {
    "value": "var(--wa-colors-purple-800)",
    "variable": "var(--wa-colors-text-accent-purple-dark)"
  },
  "colors.text.accent.purple.mid": {
    "value": "var(--wa-colors-purple-600)",
    "variable": "var(--wa-colors-text-accent-purple-mid)"
  },
  "colors.text.accent.purple.light": {
    "value": "var(--wa-colors-purple-400)",
    "variable": "var(--wa-colors-text-accent-purple-light)"
  },
  "colors.text.accent.magenta.dark": {
    "value": "var(--wa-colors-magenta-800)",
    "variable": "var(--wa-colors-text-accent-magenta-dark)"
  },
  "colors.text.accent.magenta.mid": {
    "value": "var(--wa-colors-magenta-600)",
    "variable": "var(--wa-colors-text-accent-magenta-mid)"
  },
  "colors.text.accent.magenta.light": {
    "value": "var(--wa-colors-magenta-400)",
    "variable": "var(--wa-colors-text-accent-magenta-light)"
  },
  "colors.text.accent.cream.dark": {
    "value": "var(--wa-colors-cream-800)",
    "variable": "var(--wa-colors-text-accent-cream-dark)"
  },
  "colors.text.accent.cream.mid": {
    "value": "var(--wa-colors-cream-600)",
    "variable": "var(--wa-colors-text-accent-cream-mid)"
  },
  "colors.text.accent.cream.light": {
    "value": "var(--wa-colors-cream-400)",
    "variable": "var(--wa-colors-text-accent-cream-light)"
  },
  "colors.text.success.dark": {
    "value": "var(--wa-colors-green-800)",
    "variable": "var(--wa-colors-text-success-dark)"
  },
  "colors.text.success.mid": {
    "value": "var(--wa-colors-green-600)",
    "variable": "var(--wa-colors-text-success-mid)"
  },
  "colors.text.success.light": {
    "value": "var(--wa-colors-green-400)",
    "variable": "var(--wa-colors-text-success-light)"
  },
  "colors.text.warning.dark": {
    "value": "var(--wa-colors-orange-800)",
    "variable": "var(--wa-colors-text-warning-dark)"
  },
  "colors.text.warning.mid": {
    "value": "var(--wa-colors-orange-600)",
    "variable": "var(--wa-colors-text-warning-mid)"
  },
  "colors.text.warning.light": {
    "value": "var(--wa-colors-orange-400)",
    "variable": "var(--wa-colors-text-warning-light)"
  },
  "colors.text.error.dark": {
    "value": "var(--wa-colors-red-800)",
    "variable": "var(--wa-colors-text-error-dark)"
  },
  "colors.text.error.mid": {
    "value": "var(--wa-colors-red-600)",
    "variable": "var(--wa-colors-text-error-mid)"
  },
  "colors.text.error.light": {
    "value": "var(--wa-colors-red-400)",
    "variable": "var(--wa-colors-text-error-light)"
  },
  "colors.text.highlight.dark": {
    "value": "var(--wa-colors-yellow-800)",
    "variable": "var(--wa-colors-text-highlight-dark)"
  },
  "colors.text.highlight.mid": {
    "value": "var(--wa-colors-yellow-600)",
    "variable": "var(--wa-colors-text-highlight-mid)"
  },
  "colors.text.highlight.light": {
    "value": "var(--wa-colors-yellow-400)",
    "variable": "var(--wa-colors-text-highlight-light)"
  },
  "colors.bg.darkest": {
    "value": "var(--wa-colors-ink-1000)",
    "variable": "var(--wa-colors-bg-darkest)"
  },
  "colors.bg.dark": {
    "value": "var(--wa-colors-ink-800)",
    "variable": "var(--wa-colors-bg-dark)"
  },
  "colors.bg.mid": {
    "value": "var(--wa-colors-ink-600)",
    "variable": "var(--wa-colors-bg-mid)"
  },
  "colors.bg.lighter": {
    "value": "var(--wa-colors-ink-400)",
    "variable": "var(--wa-colors-bg-lighter)"
  },
  "colors.bg.subtle": {
    "value": "var(--wa-colors-ink-300)",
    "variable": "var(--wa-colors-bg-subtle)"
  },
  "colors.bg.lightest": {
    "value": "var(--wa-colors-ink-200)",
    "variable": "var(--wa-colors-bg-lightest)"
  },
  "colors.bg.subtlest": {
    "value": "var(--wa-colors-ink-100)",
    "variable": "var(--wa-colors-bg-subtlest)"
  },
  "colors.bg.accent.blue.darkest": {
    "value": "var(--wa-colors-blue-800)",
    "variable": "var(--wa-colors-bg-accent-blue-darkest)"
  },
  "colors.bg.accent.blue.dark": {
    "value": "var(--wa-colors-blue-600)",
    "variable": "var(--wa-colors-bg-accent-blue-dark)"
  },
  "colors.bg.accent.blue.mid": {
    "value": "var(--wa-colors-blue-400)",
    "variable": "var(--wa-colors-bg-accent-blue-mid)"
  },
  "colors.bg.accent.blue.light": {
    "value": "var(--wa-colors-blue-200)",
    "variable": "var(--wa-colors-bg-accent-blue-light)"
  },
  "colors.bg.accent.blue.lightest": {
    "value": "var(--wa-colors-blue-100)",
    "variable": "var(--wa-colors-bg-accent-blue-lightest)"
  },
  "colors.bg.accent.purple.darkest": {
    "value": "var(--wa-colors-purple-800)",
    "variable": "var(--wa-colors-bg-accent-purple-darkest)"
  },
  "colors.bg.accent.purple.dark": {
    "value": "var(--wa-colors-purple-600)",
    "variable": "var(--wa-colors-bg-accent-purple-dark)"
  },
  "colors.bg.accent.purple.mid": {
    "value": "var(--wa-colors-purple-400)",
    "variable": "var(--wa-colors-bg-accent-purple-mid)"
  },
  "colors.bg.accent.purple.light": {
    "value": "var(--wa-colors-purple-200)",
    "variable": "var(--wa-colors-bg-accent-purple-light)"
  },
  "colors.bg.accent.purple.lightest": {
    "value": "var(--wa-colors-purple-100)",
    "variable": "var(--wa-colors-bg-accent-purple-lightest)"
  },
  "colors.bg.accent.magenta.darkest": {
    "value": "var(--wa-colors-magenta-800)",
    "variable": "var(--wa-colors-bg-accent-magenta-darkest)"
  },
  "colors.bg.accent.magenta.dark": {
    "value": "var(--wa-colors-magenta-600)",
    "variable": "var(--wa-colors-bg-accent-magenta-dark)"
  },
  "colors.bg.accent.magenta.mid": {
    "value": "var(--wa-colors-magenta-400)",
    "variable": "var(--wa-colors-bg-accent-magenta-mid)"
  },
  "colors.bg.accent.magenta.light": {
    "value": "var(--wa-colors-magenta-200)",
    "variable": "var(--wa-colors-bg-accent-magenta-light)"
  },
  "colors.bg.accent.magenta.lightest": {
    "value": "var(--wa-colors-magenta-100)",
    "variable": "var(--wa-colors-bg-accent-magenta-lightest)"
  },
  "colors.bg.success.darkest": {
    "value": "var(--wa-colors-green-800)",
    "variable": "var(--wa-colors-bg-success-darkest)"
  },
  "colors.bg.success.dark": {
    "value": "var(--wa-colors-green-600)",
    "variable": "var(--wa-colors-bg-success-dark)"
  },
  "colors.bg.success.mid": {
    "value": "var(--wa-colors-green-400)",
    "variable": "var(--wa-colors-bg-success-mid)"
  },
  "colors.bg.success.light": {
    "value": "var(--wa-colors-green-200)",
    "variable": "var(--wa-colors-bg-success-light)"
  },
  "colors.bg.success.lightest": {
    "value": "var(--wa-colors-green-100)",
    "variable": "var(--wa-colors-bg-success-lightest)"
  },
  "colors.bg.warning.darkest": {
    "value": "var(--wa-colors-orange-800)",
    "variable": "var(--wa-colors-bg-warning-darkest)"
  },
  "colors.bg.warning.dark": {
    "value": "var(--wa-colors-orange-600)",
    "variable": "var(--wa-colors-bg-warning-dark)"
  },
  "colors.bg.warning.mid": {
    "value": "var(--wa-colors-orange-400)",
    "variable": "var(--wa-colors-bg-warning-mid)"
  },
  "colors.bg.warning.light": {
    "value": "var(--wa-colors-orange-200)",
    "variable": "var(--wa-colors-bg-warning-light)"
  },
  "colors.bg.warning.lightest": {
    "value": "var(--wa-colors-orange-100)",
    "variable": "var(--wa-colors-bg-warning-lightest)"
  },
  "colors.bg.error.darkest": {
    "value": "var(--wa-colors-red-800)",
    "variable": "var(--wa-colors-bg-error-darkest)"
  },
  "colors.bg.error.dark": {
    "value": "var(--wa-colors-red-600)",
    "variable": "var(--wa-colors-bg-error-dark)"
  },
  "colors.bg.error.mid": {
    "value": "var(--wa-colors-red-400)",
    "variable": "var(--wa-colors-bg-error-mid)"
  },
  "colors.bg.error.light": {
    "value": "var(--wa-colors-red-200)",
    "variable": "var(--wa-colors-bg-error-light)"
  },
  "colors.bg.error.lightest": {
    "value": "var(--wa-colors-red-100)",
    "variable": "var(--wa-colors-bg-error-lightest)"
  },
  "colors.bg.highlight.darkest": {
    "value": "var(--wa-colors-yellow-800)",
    "variable": "var(--wa-colors-bg-highlight-darkest)"
  },
  "colors.bg.highlight.dark": {
    "value": "var(--wa-colors-yellow-600)",
    "variable": "var(--wa-colors-bg-highlight-dark)"
  },
  "colors.bg.highlight.mid": {
    "value": "var(--wa-colors-yellow-400)",
    "variable": "var(--wa-colors-bg-highlight-mid)"
  },
  "colors.bg.highlight.light": {
    "value": "var(--wa-colors-yellow-200)",
    "variable": "var(--wa-colors-bg-highlight-light)"
  },
  "colors.bg.highlight.lightest": {
    "value": "var(--wa-colors-yellow-100)",
    "variable": "var(--wa-colors-bg-highlight-lightest)"
  },
  "colors.bg.wa.darkest": {
    "value": "var(--wa-colors-cream-800)",
    "variable": "var(--wa-colors-bg-wa-darkest)"
  },
  "colors.bg.wa.dark": {
    "value": "var(--wa-colors-cream-600)",
    "variable": "var(--wa-colors-bg-wa-dark)"
  },
  "colors.bg.wa.mid": {
    "value": "var(--wa-colors-cream-400)",
    "variable": "var(--wa-colors-bg-wa-mid)"
  },
  "colors.bg.wa.light": {
    "value": "var(--wa-colors-cream-200)",
    "variable": "var(--wa-colors-bg-wa-light)"
  },
  "colors.bg.wa.lightest": {
    "value": "var(--wa-colors-cream-100)",
    "variable": "var(--wa-colors-bg-wa-lightest)"
  },
  "colors.icon.dark": {
    "value": "var(--wa-colors-ink-1000)",
    "variable": "var(--wa-colors-icon-dark)"
  },
  "colors.icon.mid": {
    "value": "var(--wa-colors-ink-800)",
    "variable": "var(--wa-colors-icon-mid)"
  },
  "colors.icon.light": {
    "value": "var(--wa-colors-ink-600)",
    "variable": "var(--wa-colors-icon-light)"
  },
  "colors.icon.disabled": {
    "value": "var(--wa-colors-ink-400)",
    "variable": "var(--wa-colors-icon-disabled)"
  },
  "colors.icon.inverse": {
    "value": "white",
    "variable": "var(--wa-colors-icon-inverse)"
  },
  "colors.icon.accent.blue.dark": {
    "value": "var(--wa-colors-blue-800)",
    "variable": "var(--wa-colors-icon-accent-blue-dark)"
  },
  "colors.icon.accent.blue.mid": {
    "value": "var(--wa-colors-blue-600)",
    "variable": "var(--wa-colors-icon-accent-blue-mid)"
  },
  "colors.icon.accent.blue.light": {
    "value": "var(--wa-colors-blue-400)",
    "variable": "var(--wa-colors-icon-accent-blue-light)"
  },
  "colors.icon.accent.purple.dark": {
    "value": "var(--wa-colors-purple-800)",
    "variable": "var(--wa-colors-icon-accent-purple-dark)"
  },
  "colors.icon.accent.purple.mid": {
    "value": "var(--wa-colors-purple-600)",
    "variable": "var(--wa-colors-icon-accent-purple-mid)"
  },
  "colors.icon.accent.purple.light": {
    "value": "var(--wa-colors-purple-400)",
    "variable": "var(--wa-colors-icon-accent-purple-light)"
  },
  "colors.icon.accent.magenta.dark": {
    "value": "var(--wa-colors-magenta-800)",
    "variable": "var(--wa-colors-icon-accent-magenta-dark)"
  },
  "colors.icon.accent.magenta.mid": {
    "value": "var(--wa-colors-magenta-600)",
    "variable": "var(--wa-colors-icon-accent-magenta-mid)"
  },
  "colors.icon.accent.magenta.light": {
    "value": "var(--wa-colors-magenta-400)",
    "variable": "var(--wa-colors-icon-accent-magenta-light)"
  },
  "colors.icon.accent.cream.dark": {
    "value": "var(--wa-colors-cream-800)",
    "variable": "var(--wa-colors-icon-accent-cream-dark)"
  },
  "colors.icon.accent.cream.mid": {
    "value": "var(--wa-colors-cream-600)",
    "variable": "var(--wa-colors-icon-accent-cream-mid)"
  },
  "colors.icon.accent.cream.light": {
    "value": "var(--wa-colors-cream-400)",
    "variable": "var(--wa-colors-icon-accent-cream-light)"
  },
  "colors.icon.success.dark": {
    "value": "var(--wa-colors-green-800)",
    "variable": "var(--wa-colors-icon-success-dark)"
  },
  "colors.icon.success.mid": {
    "value": "var(--wa-colors-green-600)",
    "variable": "var(--wa-colors-icon-success-mid)"
  },
  "colors.icon.success.light": {
    "value": "var(--wa-colors-green-400)",
    "variable": "var(--wa-colors-icon-success-light)"
  },
  "colors.icon.warning.dark": {
    "value": "var(--wa-colors-orange-800)",
    "variable": "var(--wa-colors-icon-warning-dark)"
  },
  "colors.icon.warning.mid": {
    "value": "var(--wa-colors-orange-600)",
    "variable": "var(--wa-colors-icon-warning-mid)"
  },
  "colors.icon.warning.light": {
    "value": "var(--wa-colors-orange-400)",
    "variable": "var(--wa-colors-icon-warning-light)"
  },
  "colors.icon.error.dark": {
    "value": "var(--wa-colors-red-800)",
    "variable": "var(--wa-colors-icon-error-dark)"
  },
  "colors.icon.error.mid": {
    "value": "var(--wa-colors-red-600)",
    "variable": "var(--wa-colors-icon-error-mid)"
  },
  "colors.icon.error.light": {
    "value": "var(--wa-colors-red-400)",
    "variable": "var(--wa-colors-icon-error-light)"
  },
  "colors.icon.highlight.dark": {
    "value": "var(--wa-colors-yellow-800)",
    "variable": "var(--wa-colors-icon-highlight-dark)"
  },
  "colors.icon.highlight.mid": {
    "value": "var(--wa-colors-yellow-600)",
    "variable": "var(--wa-colors-icon-highlight-mid)"
  },
  "colors.icon.highlight.light": {
    "value": "var(--wa-colors-yellow-400)",
    "variable": "var(--wa-colors-icon-highlight-light)"
  },
  "colors.border.dark": {
    "value": "var(--wa-colors-ink-1000)",
    "variable": "var(--wa-colors-border-dark)"
  },
  "colors.border.mid": {
    "value": "var(--wa-colors-ink-600)",
    "variable": "var(--wa-colors-border-mid)"
  },
  "colors.border.light": {
    "value": "var(--wa-colors-ink-400)",
    "variable": "var(--wa-colors-border-light)"
  },
  "colors.border.lightest": {
    "value": "var(--wa-colors-ink-300)",
    "variable": "var(--wa-colors-border-lightest)"
  },
  "colors.border.disabled": {
    "value": "var(--wa-colors-ink-200)",
    "variable": "var(--wa-colors-border-disabled)"
  },
  "colors.border.accent.blue": {
    "value": "var(--wa-colors-blue-600)",
    "variable": "var(--wa-colors-border-accent-blue)"
  },
  "colors.border.accent.purple": {
    "value": "var(--wa-colors-purple-600)",
    "variable": "var(--wa-colors-border-accent-purple)"
  },
  "colors.border.accent.magenta": {
    "value": "var(--wa-colors-magenta-600)",
    "variable": "var(--wa-colors-border-accent-magenta)"
  },
  "colors.border.accent.cream": {
    "value": "var(--wa-colors-cream-600)",
    "variable": "var(--wa-colors-border-accent-cream)"
  },
  "colors.border.success": {
    "value": "var(--wa-colors-green-600)",
    "variable": "var(--wa-colors-border-success)"
  },
  "colors.border.warning": {
    "value": "var(--wa-colors-orange-600)",
    "variable": "var(--wa-colors-border-warning)"
  },
  "colors.border.error": {
    "value": "var(--wa-colors-red-600)",
    "variable": "var(--wa-colors-border-error)"
  },
  "colors.border.highlight": {
    "value": "var(--wa-colors-yellow-600)",
    "variable": "var(--wa-colors-border-highlight)"
  },
  "spacing.-1": {
    "value": "calc(var(--wa-spacing-1) * -1)",
    "variable": "var(--wa-spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--wa-spacing-2) * -1)",
    "variable": "var(--wa-spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--wa-spacing-3) * -1)",
    "variable": "var(--wa-spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--wa-spacing-4) * -1)",
    "variable": "var(--wa-spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--wa-spacing-5) * -1)",
    "variable": "var(--wa-spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--wa-spacing-6) * -1)",
    "variable": "var(--wa-spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--wa-spacing-7) * -1)",
    "variable": "var(--wa-spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--wa-spacing-8) * -1)",
    "variable": "var(--wa-spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--wa-spacing-9) * -1)",
    "variable": "var(--wa-spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--wa-spacing-10) * -1)",
    "variable": "var(--wa-spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--wa-spacing-11) * -1)",
    "variable": "var(--wa-spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--wa-spacing-12) * -1)",
    "variable": "var(--wa-spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--wa-spacing-14) * -1)",
    "variable": "var(--wa-spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--wa-spacing-16) * -1)",
    "variable": "var(--wa-spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--wa-spacing-20) * -1)",
    "variable": "var(--wa-spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--wa-spacing-24) * -1)",
    "variable": "var(--wa-spacing-24)"
  },
  "spacing.-25": {
    "value": "calc(var(--wa-spacing-25) * -1)",
    "variable": "var(--wa-spacing-25)"
  },
  "spacing.-28": {
    "value": "calc(var(--wa-spacing-28) * -1)",
    "variable": "var(--wa-spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--wa-spacing-32) * -1)",
    "variable": "var(--wa-spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--wa-spacing-36) * -1)",
    "variable": "var(--wa-spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--wa-spacing-40) * -1)",
    "variable": "var(--wa-spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--wa-spacing-44) * -1)",
    "variable": "var(--wa-spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--wa-spacing-48) * -1)",
    "variable": "var(--wa-spacing-48)"
  },
  "spacing.-50": {
    "value": "calc(var(--wa-spacing-50) * -1)",
    "variable": "var(--wa-spacing-50)"
  },
  "spacing.-52": {
    "value": "calc(var(--wa-spacing-52) * -1)",
    "variable": "var(--wa-spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--wa-spacing-56) * -1)",
    "variable": "var(--wa-spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--wa-spacing-60) * -1)",
    "variable": "var(--wa-spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--wa-spacing-64) * -1)",
    "variable": "var(--wa-spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--wa-spacing-72) * -1)",
    "variable": "var(--wa-spacing-72)"
  },
  "spacing.-75": {
    "value": "calc(var(--wa-spacing-75) * -1)",
    "variable": "var(--wa-spacing-75)"
  },
  "spacing.-80": {
    "value": "calc(var(--wa-spacing-80) * -1)",
    "variable": "var(--wa-spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--wa-spacing-96) * -1)",
    "variable": "var(--wa-spacing-96)"
  },
  "spacing.-100": {
    "value": "calc(var(--wa-spacing-100) * -1)",
    "variable": "var(--wa-spacing-100)"
  },
  "spacing.-150": {
    "value": "calc(var(--wa-spacing-150) * -1)",
    "variable": "var(--wa-spacing-150)"
  },
  "spacing.-200": {
    "value": "calc(var(--wa-spacing-200) * -1)",
    "variable": "var(--wa-spacing-200)"
  },
  "spacing.-250": {
    "value": "calc(var(--wa-spacing-250) * -1)",
    "variable": "var(--wa-spacing-250)"
  },
  "spacing.-300": {
    "value": "calc(var(--wa-spacing-300) * -1)",
    "variable": "var(--wa-spacing-300)"
  },
  "spacing.-400": {
    "value": "calc(var(--wa-spacing-400) * -1)",
    "variable": "var(--wa-spacing-400)"
  },
  "spacing.-500": {
    "value": "calc(var(--wa-spacing-500) * -1)",
    "variable": "var(--wa-spacing-500)"
  },
  "spacing.-600": {
    "value": "calc(var(--wa-spacing-600) * -1)",
    "variable": "var(--wa-spacing-600)"
  },
  "spacing.-800": {
    "value": "calc(var(--wa-spacing-800) * -1)",
    "variable": "var(--wa-spacing-800)"
  },
  "spacing.-1000": {
    "value": "calc(var(--wa-spacing-1000) * -1)",
    "variable": "var(--wa-spacing-1000)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--wa-spacing-0\\.5) * -1)",
    "variable": "var(--wa-spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--wa-spacing-1\\.5) * -1)",
    "variable": "var(--wa-spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--wa-spacing-2\\.5) * -1)",
    "variable": "var(--wa-spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--wa-spacing-3\\.5) * -1)",
    "variable": "var(--wa-spacing-3\\.5)"
  },
  "colors.colorPalette": {
    "value": "var(--wa-colors-color-palette)",
    "variable": "var(--wa-colors-color-palette)"
  },
  "colors.colorPalette.50": {
    "value": "var(--wa-colors-color-palette-50)",
    "variable": "var(--wa-colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--wa-colors-color-palette-100)",
    "variable": "var(--wa-colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--wa-colors-color-palette-200)",
    "variable": "var(--wa-colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--wa-colors-color-palette-300)",
    "variable": "var(--wa-colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--wa-colors-color-palette-400)",
    "variable": "var(--wa-colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--wa-colors-color-palette-500)",
    "variable": "var(--wa-colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--wa-colors-color-palette-600)",
    "variable": "var(--wa-colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--wa-colors-color-palette-700)",
    "variable": "var(--wa-colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--wa-colors-color-palette-800)",
    "variable": "var(--wa-colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--wa-colors-color-palette-900)",
    "variable": "var(--wa-colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--wa-colors-color-palette-950)",
    "variable": "var(--wa-colors-color-palette-950)"
  },
  "colors.colorPalette.0": {
    "value": "var(--wa-colors-color-palette-0)",
    "variable": "var(--wa-colors-color-palette-0)"
  },
  "colors.colorPalette.1000": {
    "value": "var(--wa-colors-color-palette-1000)",
    "variable": "var(--wa-colors-color-palette-1000)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--wa-colors-color-palette-dark)",
    "variable": "var(--wa-colors-color-palette-dark)"
  },
  "colors.colorPalette.mid": {
    "value": "var(--wa-colors-color-palette-mid)",
    "variable": "var(--wa-colors-color-palette-mid)"
  },
  "colors.colorPalette.light": {
    "value": "var(--wa-colors-color-palette-light)",
    "variable": "var(--wa-colors-color-palette-light)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--wa-colors-color-palette-disabled)",
    "variable": "var(--wa-colors-color-palette-disabled)"
  },
  "colors.colorPalette.inverse": {
    "value": "var(--wa-colors-color-palette-inverse)",
    "variable": "var(--wa-colors-color-palette-inverse)"
  },
  "colors.colorPalette.accent.blue.dark": {
    "value": "var(--wa-colors-color-palette-accent-blue-dark)",
    "variable": "var(--wa-colors-color-palette-accent-blue-dark)"
  },
  "colors.colorPalette.blue.dark": {
    "value": "var(--wa-colors-color-palette-blue-dark)",
    "variable": "var(--wa-colors-color-palette-blue-dark)"
  },
  "colors.colorPalette.accent.blue.mid": {
    "value": "var(--wa-colors-color-palette-accent-blue-mid)",
    "variable": "var(--wa-colors-color-palette-accent-blue-mid)"
  },
  "colors.colorPalette.blue.mid": {
    "value": "var(--wa-colors-color-palette-blue-mid)",
    "variable": "var(--wa-colors-color-palette-blue-mid)"
  },
  "colors.colorPalette.accent.blue.light": {
    "value": "var(--wa-colors-color-palette-accent-blue-light)",
    "variable": "var(--wa-colors-color-palette-accent-blue-light)"
  },
  "colors.colorPalette.blue.light": {
    "value": "var(--wa-colors-color-palette-blue-light)",
    "variable": "var(--wa-colors-color-palette-blue-light)"
  },
  "colors.colorPalette.accent.purple.dark": {
    "value": "var(--wa-colors-color-palette-accent-purple-dark)",
    "variable": "var(--wa-colors-color-palette-accent-purple-dark)"
  },
  "colors.colorPalette.purple.dark": {
    "value": "var(--wa-colors-color-palette-purple-dark)",
    "variable": "var(--wa-colors-color-palette-purple-dark)"
  },
  "colors.colorPalette.accent.purple.mid": {
    "value": "var(--wa-colors-color-palette-accent-purple-mid)",
    "variable": "var(--wa-colors-color-palette-accent-purple-mid)"
  },
  "colors.colorPalette.purple.mid": {
    "value": "var(--wa-colors-color-palette-purple-mid)",
    "variable": "var(--wa-colors-color-palette-purple-mid)"
  },
  "colors.colorPalette.accent.purple.light": {
    "value": "var(--wa-colors-color-palette-accent-purple-light)",
    "variable": "var(--wa-colors-color-palette-accent-purple-light)"
  },
  "colors.colorPalette.purple.light": {
    "value": "var(--wa-colors-color-palette-purple-light)",
    "variable": "var(--wa-colors-color-palette-purple-light)"
  },
  "colors.colorPalette.accent.magenta.dark": {
    "value": "var(--wa-colors-color-palette-accent-magenta-dark)",
    "variable": "var(--wa-colors-color-palette-accent-magenta-dark)"
  },
  "colors.colorPalette.magenta.dark": {
    "value": "var(--wa-colors-color-palette-magenta-dark)",
    "variable": "var(--wa-colors-color-palette-magenta-dark)"
  },
  "colors.colorPalette.accent.magenta.mid": {
    "value": "var(--wa-colors-color-palette-accent-magenta-mid)",
    "variable": "var(--wa-colors-color-palette-accent-magenta-mid)"
  },
  "colors.colorPalette.magenta.mid": {
    "value": "var(--wa-colors-color-palette-magenta-mid)",
    "variable": "var(--wa-colors-color-palette-magenta-mid)"
  },
  "colors.colorPalette.accent.magenta.light": {
    "value": "var(--wa-colors-color-palette-accent-magenta-light)",
    "variable": "var(--wa-colors-color-palette-accent-magenta-light)"
  },
  "colors.colorPalette.magenta.light": {
    "value": "var(--wa-colors-color-palette-magenta-light)",
    "variable": "var(--wa-colors-color-palette-magenta-light)"
  },
  "colors.colorPalette.accent.cream.dark": {
    "value": "var(--wa-colors-color-palette-accent-cream-dark)",
    "variable": "var(--wa-colors-color-palette-accent-cream-dark)"
  },
  "colors.colorPalette.cream.dark": {
    "value": "var(--wa-colors-color-palette-cream-dark)",
    "variable": "var(--wa-colors-color-palette-cream-dark)"
  },
  "colors.colorPalette.accent.cream.mid": {
    "value": "var(--wa-colors-color-palette-accent-cream-mid)",
    "variable": "var(--wa-colors-color-palette-accent-cream-mid)"
  },
  "colors.colorPalette.cream.mid": {
    "value": "var(--wa-colors-color-palette-cream-mid)",
    "variable": "var(--wa-colors-color-palette-cream-mid)"
  },
  "colors.colorPalette.accent.cream.light": {
    "value": "var(--wa-colors-color-palette-accent-cream-light)",
    "variable": "var(--wa-colors-color-palette-accent-cream-light)"
  },
  "colors.colorPalette.cream.light": {
    "value": "var(--wa-colors-color-palette-cream-light)",
    "variable": "var(--wa-colors-color-palette-cream-light)"
  },
  "colors.colorPalette.success.dark": {
    "value": "var(--wa-colors-color-palette-success-dark)",
    "variable": "var(--wa-colors-color-palette-success-dark)"
  },
  "colors.colorPalette.success.mid": {
    "value": "var(--wa-colors-color-palette-success-mid)",
    "variable": "var(--wa-colors-color-palette-success-mid)"
  },
  "colors.colorPalette.success.light": {
    "value": "var(--wa-colors-color-palette-success-light)",
    "variable": "var(--wa-colors-color-palette-success-light)"
  },
  "colors.colorPalette.warning.dark": {
    "value": "var(--wa-colors-color-palette-warning-dark)",
    "variable": "var(--wa-colors-color-palette-warning-dark)"
  },
  "colors.colorPalette.warning.mid": {
    "value": "var(--wa-colors-color-palette-warning-mid)",
    "variable": "var(--wa-colors-color-palette-warning-mid)"
  },
  "colors.colorPalette.warning.light": {
    "value": "var(--wa-colors-color-palette-warning-light)",
    "variable": "var(--wa-colors-color-palette-warning-light)"
  },
  "colors.colorPalette.error.dark": {
    "value": "var(--wa-colors-color-palette-error-dark)",
    "variable": "var(--wa-colors-color-palette-error-dark)"
  },
  "colors.colorPalette.error.mid": {
    "value": "var(--wa-colors-color-palette-error-mid)",
    "variable": "var(--wa-colors-color-palette-error-mid)"
  },
  "colors.colorPalette.error.light": {
    "value": "var(--wa-colors-color-palette-error-light)",
    "variable": "var(--wa-colors-color-palette-error-light)"
  },
  "colors.colorPalette.highlight.dark": {
    "value": "var(--wa-colors-color-palette-highlight-dark)",
    "variable": "var(--wa-colors-color-palette-highlight-dark)"
  },
  "colors.colorPalette.highlight.mid": {
    "value": "var(--wa-colors-color-palette-highlight-mid)",
    "variable": "var(--wa-colors-color-palette-highlight-mid)"
  },
  "colors.colorPalette.highlight.light": {
    "value": "var(--wa-colors-color-palette-highlight-light)",
    "variable": "var(--wa-colors-color-palette-highlight-light)"
  },
  "colors.colorPalette.darkest": {
    "value": "var(--wa-colors-color-palette-darkest)",
    "variable": "var(--wa-colors-color-palette-darkest)"
  },
  "colors.colorPalette.lighter": {
    "value": "var(--wa-colors-color-palette-lighter)",
    "variable": "var(--wa-colors-color-palette-lighter)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--wa-colors-color-palette-subtle)",
    "variable": "var(--wa-colors-color-palette-subtle)"
  },
  "colors.colorPalette.lightest": {
    "value": "var(--wa-colors-color-palette-lightest)",
    "variable": "var(--wa-colors-color-palette-lightest)"
  },
  "colors.colorPalette.subtlest": {
    "value": "var(--wa-colors-color-palette-subtlest)",
    "variable": "var(--wa-colors-color-palette-subtlest)"
  },
  "colors.colorPalette.accent.blue.darkest": {
    "value": "var(--wa-colors-color-palette-accent-blue-darkest)",
    "variable": "var(--wa-colors-color-palette-accent-blue-darkest)"
  },
  "colors.colorPalette.blue.darkest": {
    "value": "var(--wa-colors-color-palette-blue-darkest)",
    "variable": "var(--wa-colors-color-palette-blue-darkest)"
  },
  "colors.colorPalette.accent.blue.lightest": {
    "value": "var(--wa-colors-color-palette-accent-blue-lightest)",
    "variable": "var(--wa-colors-color-palette-accent-blue-lightest)"
  },
  "colors.colorPalette.blue.lightest": {
    "value": "var(--wa-colors-color-palette-blue-lightest)",
    "variable": "var(--wa-colors-color-palette-blue-lightest)"
  },
  "colors.colorPalette.accent.purple.darkest": {
    "value": "var(--wa-colors-color-palette-accent-purple-darkest)",
    "variable": "var(--wa-colors-color-palette-accent-purple-darkest)"
  },
  "colors.colorPalette.purple.darkest": {
    "value": "var(--wa-colors-color-palette-purple-darkest)",
    "variable": "var(--wa-colors-color-palette-purple-darkest)"
  },
  "colors.colorPalette.accent.purple.lightest": {
    "value": "var(--wa-colors-color-palette-accent-purple-lightest)",
    "variable": "var(--wa-colors-color-palette-accent-purple-lightest)"
  },
  "colors.colorPalette.purple.lightest": {
    "value": "var(--wa-colors-color-palette-purple-lightest)",
    "variable": "var(--wa-colors-color-palette-purple-lightest)"
  },
  "colors.colorPalette.accent.magenta.darkest": {
    "value": "var(--wa-colors-color-palette-accent-magenta-darkest)",
    "variable": "var(--wa-colors-color-palette-accent-magenta-darkest)"
  },
  "colors.colorPalette.magenta.darkest": {
    "value": "var(--wa-colors-color-palette-magenta-darkest)",
    "variable": "var(--wa-colors-color-palette-magenta-darkest)"
  },
  "colors.colorPalette.accent.magenta.lightest": {
    "value": "var(--wa-colors-color-palette-accent-magenta-lightest)",
    "variable": "var(--wa-colors-color-palette-accent-magenta-lightest)"
  },
  "colors.colorPalette.magenta.lightest": {
    "value": "var(--wa-colors-color-palette-magenta-lightest)",
    "variable": "var(--wa-colors-color-palette-magenta-lightest)"
  },
  "colors.colorPalette.success.darkest": {
    "value": "var(--wa-colors-color-palette-success-darkest)",
    "variable": "var(--wa-colors-color-palette-success-darkest)"
  },
  "colors.colorPalette.success.lightest": {
    "value": "var(--wa-colors-color-palette-success-lightest)",
    "variable": "var(--wa-colors-color-palette-success-lightest)"
  },
  "colors.colorPalette.warning.darkest": {
    "value": "var(--wa-colors-color-palette-warning-darkest)",
    "variable": "var(--wa-colors-color-palette-warning-darkest)"
  },
  "colors.colorPalette.warning.lightest": {
    "value": "var(--wa-colors-color-palette-warning-lightest)",
    "variable": "var(--wa-colors-color-palette-warning-lightest)"
  },
  "colors.colorPalette.error.darkest": {
    "value": "var(--wa-colors-color-palette-error-darkest)",
    "variable": "var(--wa-colors-color-palette-error-darkest)"
  },
  "colors.colorPalette.error.lightest": {
    "value": "var(--wa-colors-color-palette-error-lightest)",
    "variable": "var(--wa-colors-color-palette-error-lightest)"
  },
  "colors.colorPalette.highlight.darkest": {
    "value": "var(--wa-colors-color-palette-highlight-darkest)",
    "variable": "var(--wa-colors-color-palette-highlight-darkest)"
  },
  "colors.colorPalette.highlight.lightest": {
    "value": "var(--wa-colors-color-palette-highlight-lightest)",
    "variable": "var(--wa-colors-color-palette-highlight-lightest)"
  },
  "colors.colorPalette.wa.darkest": {
    "value": "var(--wa-colors-color-palette-wa-darkest)",
    "variable": "var(--wa-colors-color-palette-wa-darkest)"
  },
  "colors.colorPalette.wa.dark": {
    "value": "var(--wa-colors-color-palette-wa-dark)",
    "variable": "var(--wa-colors-color-palette-wa-dark)"
  },
  "colors.colorPalette.wa.mid": {
    "value": "var(--wa-colors-color-palette-wa-mid)",
    "variable": "var(--wa-colors-color-palette-wa-mid)"
  },
  "colors.colorPalette.wa.light": {
    "value": "var(--wa-colors-color-palette-wa-light)",
    "variable": "var(--wa-colors-color-palette-wa-light)"
  },
  "colors.colorPalette.wa.lightest": {
    "value": "var(--wa-colors-color-palette-wa-lightest)",
    "variable": "var(--wa-colors-color-palette-wa-lightest)"
  },
  "colors.colorPalette.accent.blue": {
    "value": "var(--wa-colors-color-palette-accent-blue)",
    "variable": "var(--wa-colors-color-palette-accent-blue)"
  },
  "colors.colorPalette.blue": {
    "value": "var(--wa-colors-color-palette-blue)",
    "variable": "var(--wa-colors-color-palette-blue)"
  },
  "colors.colorPalette.accent.purple": {
    "value": "var(--wa-colors-color-palette-accent-purple)",
    "variable": "var(--wa-colors-color-palette-accent-purple)"
  },
  "colors.colorPalette.purple": {
    "value": "var(--wa-colors-color-palette-purple)",
    "variable": "var(--wa-colors-color-palette-purple)"
  },
  "colors.colorPalette.accent.magenta": {
    "value": "var(--wa-colors-color-palette-accent-magenta)",
    "variable": "var(--wa-colors-color-palette-accent-magenta)"
  },
  "colors.colorPalette.magenta": {
    "value": "var(--wa-colors-color-palette-magenta)",
    "variable": "var(--wa-colors-color-palette-magenta)"
  },
  "colors.colorPalette.accent.cream": {
    "value": "var(--wa-colors-color-palette-accent-cream)",
    "variable": "var(--wa-colors-color-palette-accent-cream)"
  },
  "colors.colorPalette.cream": {
    "value": "var(--wa-colors-color-palette-cream)",
    "variable": "var(--wa-colors-color-palette-cream)"
  },
  "colors.colorPalette.success": {
    "value": "var(--wa-colors-color-palette-success)",
    "variable": "var(--wa-colors-color-palette-success)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--wa-colors-color-palette-warning)",
    "variable": "var(--wa-colors-color-palette-warning)"
  },
  "colors.colorPalette.error": {
    "value": "var(--wa-colors-color-palette-error)",
    "variable": "var(--wa-colors-color-palette-error)"
  },
  "colors.colorPalette.highlight": {
    "value": "var(--wa-colors-color-palette-highlight)",
    "variable": "var(--wa-colors-color-palette-highlight)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar